<template>
  <div class="footer">
    <div class="top">
      <img src="../assets/otto/foottext.png" alt="">
      <img src="../assets/otto/m1.png" alt="">
      <img src="../assets/otto/m2.png" alt="">
      <img src="../assets/otto/m3.png" alt="">
    </div>
    <div class="bottom">
      <p>奥托（包头）工业互联网有限公司_版权所有 版权所有 蒙ICP备19002649号</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  components: {},
  data() {
    return {};
  },
  methods: {
    jup() {
      this.$router.push("/contactus")
    }
  }
};
</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  height: 617px;
  background: url(../assets/otto/footbg.png) no-repeat;
  background-size: cover;
  position: relative;

  .top {
    width: 1200px;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 130px;
      margin-right: 100px;
      margin-left: 20px;
    }

    img:nth-child(1) {
      width: 341px;
      padding-top: 100px;
    }
  }

  .bottom {
    font-size: 16px;
    color: #cccc;
    position: absolute;
    bottom: 34px;
    left: 130px;

    p {
      display: table-cell;
      vertical-align: bottom;
    }

  }
}</style>